import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { ParticipantsPaneButton, mapStateToProps } from 'jitsi/participants-pane/components/web/ParticipantsPaneButton';
import ParticipantsCounter from 'jitsi/participants-pane/components/web/ParticipantsCounter';
import { setOverflowMenuVisible, setToolbarHovered } from 'jitsi/toolbox/actions.web';
class IISightParticipantsPaneButton extends ParticipantsPaneButton {
    render() {
        if (this.props.showLabel)
            return super.render();
        return (React.createElement("div", { className: 'toolbar-button-with-badge' },
            super.render(),
            React.createElement(ParticipantsCounter, null)));
    }
    /**
     * Overrides the _handleClick method to add custom behavior.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        // Custom behavior before calling the parent method
        super._handleClick();
        // Custom behavior after calling the parent method
        APP.store.dispatch(setOverflowMenuVisible(false));
        APP.store.dispatch(setToolbarHovered(false));
    }
}
export default translate(connect(mapStateToProps)(IISightParticipantsPaneButton));
